import changesetSet from 'ember-changeset/helpers/changeset-set';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import templateOnly, { TOC } from '@ember/component/template-only';
import ValidatedField from '../validated-field';
import Range from '../range';
import { fn } from '@ember/helper';
import { or } from 'ember-truth-helpers';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const ChangesetRange = setComponentTemplate(precompileTemplate("\n  <ValidatedField @propertyName={{@payloadKey}} @changeset={{@changeset}} @errorClass={{or @errorClass \"error-validated-input-display\"}}>\n    <Range @label={{@label}} @dataTest={{@payloadKey}} @min={{@min}} @max={{@max}} @step={{@step}} @value={{or (changesetGet @changeset @payloadKey) 0}} @onChange={{fn (changesetSet @changeset @payloadKey)}} ...attributes>\n      <:values>\n        {{#if (has-block \"values\")}}\n          {{yield to=\"values\"}}\n        {{/if}}\n      </:values>\n    </Range>\n  </ValidatedField>\n", {
  strictMode: true,
  scope: () => ({
    ValidatedField,
    or,
    Range,
    changesetGet,
    fn,
    changesetSet
  })
}), templateOnly(undefined, "range:ChangesetRange"));
export default ChangesetRange;